import app from '@/app';

/* @ngInject */
function Ifi($resource) {
	return $resource(
		'api/ifis/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Ifi', Ifi);
